class ProductOptions extends HTMLElement {
  constructor() {
    super();
     this.selectedProperty = [];
     this.element = this.querySelector('.flavours--render');
     this.variant = JSON.parse(this.getAttribute('data-varitant'));
     this.variants = JSON.parse(this.getAttribute('data-varitants'));
    this.variantID = this.variant.id;
     this.metafields = JSON.parse(this.getAttribute('data-metafield'));
     this.sectionid = this.getAttribute('data-sectionid');
     this.options = this.metafields.options;
      this.html = "";
      let $this = this;
      function handleQueryStringChange() {
      const queryString = $this.getQueryParams();
       
      let variantID = queryString.variant;
      if($this.variantID != variantID){
        $this.variantID = variantID;
        $this.selectedProperty = [];
        const foundElement = $this.variants.find(variant => variant.id == variantID);
        $this.variant = foundElement;
        $this.variantID = variantID;
        $this.renderOptions();
        $this.onCheckboxClick();
      }
    }
    setInterval(handleQueryStringChange, 200);
    this.renderOptions();
    this.onCheckboxClick();
    
  }

  getQueryParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (let param of searchParams.entries()) {
      params[param[0]] = param[1];
    }
    return params;
  }

  onCheckboxClick(){
     let $this = this;
     let options = this.options;
    options.forEach((option, i)=>{ 
       $this.querySelector(`#flavour--${i}`)?.addEventListener("change", (e)=>{
         const index = $this.selectedProperty.indexOf(e.target.value);
         if(index === -1){
           if($this.selectedProperty.length <= 2){
             console.log('checked');
             $this.selectedProperty.push($this.querySelector(`#flavour--${i}`).value);
           }else{
             $this.querySelector(`#flavour--${i}`).checked = false;
              console.log('uncecked');
           }
         }else{
           $this.selectedProperty.splice(index, 1);
         }
           $this.renderFormProperties();
       });
    });
  }

  renderFormProperties(){
        const form = document.querySelector(`#product-form-${this.sectionid}`);
        this.removeFormProperties(form);
        this.selectedProperty.forEach((property, i)=>{
          const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'properties[flavours][]';
                hiddenInput.classList.add('properties');
                hiddenInput.value = property;
                form.appendChild(hiddenInput);
                console.log(form);
        });
  }
  removeFormProperties(form){
    const propertiesInputs = form.querySelectorAll('.properties');
    propertiesInputs.forEach((input) => {
      input.remove();
    });
  }

  renderOptions(){
      let $this = this; 
      let variant = this.variant?.title?.toLowerCase();
      $this.html = "";
      this.options.forEach((option, i)=>{
           let optionArray = option.split(':');
           if(optionArray[0] == 'both'){
             $this.html += `<input type="checkbox" id="flavour--${i}" name="properties[flavours][]" value="${optionArray[1].toLowerCase().trim()}" />`;
              $this.html += `<label for="flavour--${i}" class="flavour--options-label">${optionArray[1].trim()}</label>`;
           }else{
             if(optionArray[0].trim() === variant){
                 $this.html += `<input type="checkbox" id="flavour--${i}" name="properties[flavours][]" value="${optionArray[1].toLowerCase().trim()}" />`;
                $this.html += `<label for="flavour--${i}" class="flavour--options-label">${optionArray[1].trim()}</label>`;
             }
           }
           
      });

     this.element.innerHTML = $this.html;
  }
}

customElements.define('product-options', ProductOptions);